import { Box, IconButton, Modal, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import closeIcon from "../assets/closeIcon.svg";

interface Props extends PropsWithChildren {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

const CustomModal = ({ isOpen, onClose, title, children }: Props) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.6)",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 850,
          bgcolor: "#1C2434",
          borderRadius: { md: 3 },
          px: 2,
          pt: { xs: 5, lg: 4 },
          pb: 4,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            id="custom-modal-title"
            variant="h4"
            component="h1"
            sx={{
              fontFamily: "Nunito, sans-serif",
              fontWeight: 600,
              color: "white",
              fontSize: { xs: "32px", md: "48px" },
              lineHeight: "50px",
            }}
          >
            {title}
          </Typography>
          <IconButton onClick={onClose} sx={{ p: 0 }}>
            <img
              src={closeIcon}
              alt="close icon"
              style={{ width: "20px", height: "20px" }}
            />
          </IconButton>
        </Box>
        <Box
          id="custom-modal-description"
          sx={{
            maxHeight: { xs: "calc(100vh - 150px)", md: "calc(100vh - 200px)" },
            overflowY: "auto",
            mt: 2,
            color: "white",
            "&::-webkit-scrollbar": {
              width: { xs: "4px", md: "8px" },
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              borderRadius: "8px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
            },
          }}
        >
          {children}
        </Box>
      </Box>
    </Modal>
  );
};

export default CustomModal;
